"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageHeaderLink = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _utils = require("../../utils");

var _layout = require("../../layout");

var _context = require("../../context");

var _propTypes = require("../../prop-types");

var _link = require("../../link");

var PageHeaderLinkDefaultProps = {
  paddingHorizontal: 'S300',
  hasHover: true
};

var PageHeaderLinkWithoutDocs = function PageHeaderLinkWithoutDocs(_ref) {
  var icon = _ref.icon,
      dataTestId = _ref.dataTestId,
      _ref$paddingHorizonta = _ref.paddingHorizontal,
      paddingHorizontal = _ref$paddingHorizonta === void 0 ? PageHeaderLinkDefaultProps.paddingHorizontal : _ref$paddingHorizonta,
      children = _ref.children,
      hasHover = _ref.hasHover,
      _ref$wrapper = _ref.wrapper,
      Wrapper = _ref$wrapper === void 0 ? _link.Link : _ref$wrapper,
      linkProps = (0, _objectWithoutProperties2.default)(_ref, ["icon", "dataTestId", "paddingHorizontal", "children", "hasHover", "wrapper"]);

  var _useContext = (0, _react.useContext)(_context.StencilContext),
      selectors = _useContext.selectors;

  var dataTestProps = (0, _utils.buildDataTestProps)({
    dataTestComponent: 'StencilReactPageHeaderLink',
    dataTestId: dataTestId
  });
  var linkCss = (0, _react.useMemo)(function () {
    return (
      /*#__PURE__*/
      (0, _core.css)({
        height: '100%',
        '&:focus': {
          outlineOffset: '-2px'
        },
        '&:hover': {
          backgroundColor: hasHover ? selectors.color('primary') : 'none',
          textDecoration: 'none'
        }
      }, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
    );
  }, [hasHover]);
  return (0, _core.jsx)(Wrapper, (0, _extends2.default)({
    padding: [0, paddingHorizontal],
    fontWeight: "regular",
    textDecoration: "none",
    color: "white",
    css: linkCss
  }, linkProps, dataTestProps), (0, _core.jsx)(_layout.Row, {
    alignItems: "center",
    gridGap: "S200",
    height: "100%"
  }, !!icon && icon, !!children && children));
};

var PageHeaderLinkStyled = PageHeaderLinkWithoutDocs;

PageHeaderLinkStyled.withComponent = function (tag) {
  var Wrapper = _link.Link.withComponent(tag, {
    target: "elyco8w0"
  });

  return function (props) {
    return (0, _core.jsx)(PageHeaderLink, (0, _extends2.default)({}, props, {
      wrapper: Wrapper
    }));
  };
};

var PageHeaderLink = (0, _stencilReactDesc.describe)(PageHeaderLinkStyled).description('Link for page header.');
exports.PageHeaderLink = PageHeaderLink;
PageHeaderLink.displayName = 'PageHeaderLink';
PageHeaderLink.defaultProps = PageHeaderLinkDefaultProps;
PageHeaderLink.propTypes = {
  paddingHorizontal: (0, _propTypes.cssValue)().description('Sets the horizontal (left and right) padding.'),
  icon: _stencilReactDesc.PropTypes.node.description('Adds an icon to the left side of the link.'),
  children: _stencilReactDesc.PropTypes.node.description('Content of the link.'),
  dataTestId: _stencilReactDesc.PropTypes.string.description("Sets the 'data-test-id' attribute in the DOM, for testing purposes.")
};